// MAX UPLOAD FILE SIZE in BYTE
export const MAX_UPLOAD_FILE_SIZE = process.env.REACT_APP_MAX_UPLOAD_FILE_SIZE;
export const MAX_UPLOAD_FILE_SIZE_ERR_MSG = 'Max upload file size is 1 MB.';


// DIMENSION
export const PRODUCT_IMAGE_D_W = process.env.REACT_APP_PRODUCT_IMAGE_D_W;
export const PRODUCT_IMAGE_D_H = process.env.REACT_APP_PRODUCT_IMAGE_D_H;

// RATIO
export const PRODUCT_IMAGE_D_RATION = parseFloat(PRODUCT_IMAGE_D_W/PRODUCT_IMAGE_D_H).toFixed(2);

// MORE IMAGE MAX QUANTITY
export const PRODUCT_MORE_IMAGE = process.env.REACT_APP_PRODUCT_MORE_IMAGE;


// COMPANY BANNER IMAGE
export const COMPANY_BANNER_IMAGE_W = process.env.REACT_APP_VENDOR_BANNER_IMAGE_W;
export const COMPANY_BANNER_IMAGE_H = process.env.REACT_APP_VENDOR_BANNER_IMAGE_H;
export const COMPANY_BANNER_IMAGE_D_RATION = parseFloat(COMPANY_BANNER_IMAGE_W/COMPANY_BANNER_IMAGE_H).toFixed(2);
